import React from 'react';
import { getUpperCaseInitials } from '../../helpers/string';
import { getRoleNameById } from '../../mappers/roleMap';
import Label from './Label';
const RoleInitial = ({ role, className }) => <Label title={getRoleNameById(role)} titleFormatter={title => getUpperCaseInitials([title])} className={className}/>;
export default RoleInitial;
